import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ProcessEventChipView } from '@app/pages/admin/orchestration-process-events.util';
import { CopyableIdentifierComponent } from '@app/pages/admin/components/copyable-identifier/copyable-identifier';

@Component({
  selector: 'app-orchestration-process-events',
  standalone: true,
  imports: [RouterModule, TranslateModule, CopyableIdentifierComponent],
  templateUrl: './orchestration-process-events.html',
  styleUrl: './orchestration-process-events.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrchestrationProcessEventsComponent {
  readonly events = input<readonly ProcessEventChipView[]>([]);
  readonly label = input('Process events');
}
